import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Typography } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import './Widgets.css';

dayjs.extend(utc);
dayjs.extend(timezone);

const { Text, Title } = Typography;

interface ClockProps {
    city: string;
    timezone: string;
    label: string;
}

// 模拟昼夜
const isDaytime = (hour: number) => hour >= 6 && hour < 18;

const ClockItem: React.FC<ClockProps> = ({ city, timezone, label }) => {
    const [time, setTime] = useState(dayjs().tz(timezone));

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(dayjs().tz(timezone));
        }, 1000);
        return () => clearInterval(timer);
    }, [timezone]);

    const hour = time.hour();
    const isDay = isDaytime(hour);
    const dayColor = isDay ? '#ff7e5f' : '#6a82fb'; // 简单的昼夜色标识

    return (
        <div className="clock-item">
            <div className="clock-city">{city}</div>
            <div className="clock-time">{time.format('HH:mm:ss')}</div>
            <div className="clock-date">
                <span className="clock-indicator" style={{ backgroundColor: dayColor }} />
                {time.format('MM-DD ddd')}
            </div>
            <div className="clock-label">{label}</div>
        </div>
    );
};

export const WorldClockCard: React.FC = () => {
    return (
        <Card title={<span><ClockCircleOutlined style={{ marginRight: 8 }} /> 全球时间</span>} className="dashboard-card world-clock-card">
            <div className="world-clock-grid">
                <ClockItem city="北京" timezone="Asia/Shanghai" label="中国 CN" />
                <ClockItem city="东京" timezone="Asia/Tokyo" label="日本 JP" />
                <ClockItem city="伦敦" timezone="Europe/London" label="英国 UK" />
                <ClockItem city="柏林" timezone="Europe/Berlin" label="德国 DE" />
                <ClockItem city="纽约" timezone="America/New_York" label="美东 EST" />
                <ClockItem city="洛杉矶" timezone="America/Los_Angeles" label="美西 PST" />
            </div>
        </Card>
    );
};
